import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from 'services/cognito/lib';
import { LocalStorageKey, removeItem } from 'services/localStorageService';

const LogoutComponent = () => {
    const navigate = useNavigate();
    useEffect(() => {
        authService.logout({
            cleanSessionInfoCallback: () => {
                removeItem(LocalStorageKey.ACCESS_TOKEN);
            },
            afterLogoutEvent: () => {
                navigate('/');
            },
        });
    }, [navigate]);

    return null;
};

export default LogoutComponent;
